function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "16",
  cy: "16",
  r: "16",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.643 16.207c0-.612-.05-1.227-.156-1.83h-8.489v3.467h4.861a4.166 4.166 0 01-1.799 2.735v2.248h2.9c1.704-1.567 2.683-3.882 2.683-6.62z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.999 25c2.427 0 4.474-.797 5.966-2.173l-2.9-2.248c-.808.549-1.85.86-3.063.86-2.348 0-4.339-1.585-5.053-3.714H7.956v2.318A9.001 9.001 0 0016 25z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.945 17.724a5.39 5.39 0 010-3.445V11.96h-2.99a9.008 9.008 0 000 8.083l2.99-2.319z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.999 10.562a4.89 4.89 0 013.452 1.349l2.57-2.57A8.65 8.65 0 0015.999 7a8.998 8.998 0 00-8.043 4.96l2.99 2.319c.71-2.133 2.705-3.717 5.053-3.717z",
  fill: "#EA4335"
})));